module.exports = __webpack_public_path__ + "static/pool-6e257048347960ce9669aad58d8cf9c8.mp4";